import _ from "lodash";
import { Article } from "../../api/schema";
import { GlobalStateContext } from "../../Context";

export const ArticleRow = ({
  article,
  selected,
  onSelect,
}: {
  article: Article;
  selected: boolean;
  onSelect: () => void;
}) => (
  <GlobalStateContext.Consumer>
    {(global_state) => {
      const row_style = {
        color: selected ? "white" : global_state.dark_mode ? "white" : "black",
        backgroundColor: selected ? "#2D72D2" : "inherit",
        padding: 10,
      };
      return _.map(
        [
          article.matchcode,
          article.footprint?.name,
          article.name,
          article.display_name,
        ],
        (value, key) => (
          <div
            key={article.id + "_" + key}
            style={row_style}
            onClick={onSelect}
          >
            {value}
          </div>
        )
      );

      // <div
      //   style={{
      //     display: "flex",
      //     flex: 1,
      //     height: 40,
      //     alignItems: "center",
      //     color: selected
      //       ? "white"
      //       : global_state.dark_mode
      //       ? "white"
      //       : "black",
      //     backgroundColor: selected ? "#2D72D2" : "inherit",
      //     alignSelf: "stretch",
      //     padding: 10,
      //     flexGrow: 2,
      //     cursor: "pointer",
      //   }}
      //   onClick={() => onSelect()}
      // >
      //   {article.matchcode +
      //     " - " +
      //     article.display_name +
      //     " - " +
      //     article.name}
      // </div>
    }}
  </GlobalStateContext.Consumer>
);
